import React, {useState} from 'react';
import {
  FlexItem,
  FlexLayout, H1
} from '@salt-ds/core';

import './CommonCard.css';

export default function ForgotPasswordSuccess() {



  return (
    <FlexLayout className={"page-content"}>
      <FlexItem>
        <H1>Congratulations, you have logged in.</H1>
      </FlexItem>
    </FlexLayout>
  );

}
